// @flow
export const WIDGET_ID = 'FREE_OR_4'
export const WIDGET_MODAL = 'widget-modal'
export const SPINNER_ID = 'fo4-spinner'
export const SPINNER_WRAPPER_ID = 'fo4-spinner-wrapper'
export const IFRAME_SOURCE_ID = 'free-or-4'
export const MESSAGE_EVENT_TYPE = 'message'
export const IFRAME_ACTION_NAVIGATE = 'navigate'
export const IFRAME_ACTION_CLOSE = 'close'
export const IFRAME_ACTION_ADDTOSLIP = 'addToSlip'
export const IFRAME_ACTION_ANALYTICS = 'analytics'
export const EVENT_PAGE = 'event'
export const HOME_PAGE = 'home'
export const SPORTCALLER_ANALYTICS_EVENT = 'sport_caller'
export const PAGEVIEW_ANALYTICS_EVENT = 'pageview'
export const MODAL = 'xs-modal'
export const MODAL_OPEN = 'xs-modal--open'
export const TOOLBAR = 'toolbar'
export const HEADER = 'header'
